export const MAX_COUNT = 10;
export const ErrorResponseMessage =
  "Something went wrong. Please try again later.";
export const UnAuthorized = "Login in again";
export const getNotApplicableMessage = (projectName) =>
  `This Screen is not applicable for ${projectName}`;
